/* esm.sh - fast-deep-equal@3.1.3 */
export * from "/*fast-deep-equal@3.1.3/esnext/fast-deep-equal.mjs";
export { default } from "/*fast-deep-equal@3.1.3/esnext/fast-deep-equal.mjs";
